const UTILS = {
  async PromisesSequential(PromiseArr) {
    let res = []
    for (let i = 0; i < PromiseArr.length; i++) {
      res.push(await PromiseArr[i])
    }
    return res
  },
  ConvertStringToHTML(str) {
    let parser = new DOMParser()
    let doc = parser.parseFromString(str, 'text/html')
    return doc.body
  },
  ConvertStringToJS(str) {
    var script = document.createElement("script")
    script.text = str
    document.head.appendChild(script).parentNode.removeChild(script)
  },
  ObserveIntersection(elementSelector, config, callback) {
    let observer = new IntersectionObserver(callback, config);
    let node = typeof elementSelector == 'string' ? document.querySelector(elementSelector) : elementSelector
    observer.observe(node, config);  
    return observer;
  }
};

(() => {
  document.addEventListener('alpine:init', () => {
    

    Alpine.data('HoverContent', (handle) => ({
     
      mounted() {
        //console.log('mounted hover content');
        let am = this
        am.LoadHover()
      
        let hoverItems = document.querySelectorAll('.hover-me')
        let childLists = document.querySelectorAll('.mega-menu__child-list') 
            new SV.HoverIntent(hoverItems, {
              onEnter: function(targetItem) {
                console.log('hover')
                let myEvent = targetItem;
                let link_loop = myEvent.getAttribute('data-loop')
                let link_id = myEvent.getAttribute('data-linklist')
                for (let i = 0; i < hoverItems.length; ++i) {
                  hoverItems[i].classList.remove('active-hover')
                }
                myEvent.classList.add('active-hover')
                am.link.first = am.link.childlinks.find(v => v.loop == link_loop )
                // hide all chidllists
                let childLists = document.querySelectorAll('.mega-menu__child-list')
                for (let i = 0; i < childLists.length; ++i) {
                  childLists[i].style.display = 'none'
                }
                // show this one
                document.getElementById(link_id).style.display = 'flex'
                
              },
              onExit: function(targetItem) {
                //targetItem.classList.remove('active-hover')
              }
            });
    
        // active state on parent menu
          new SV.HoverIntent(childLists, {
            onEnter: function(targetItem) {
              let link_id = targetItem.id
              let parentList = document.querySelector('.hover-me[data-linklist="'+link_id+'"]')
              parentList.classList.add('active-hover');
            },
            onExit: function(targetItem) {
              let link_id = targetItem.id
              let parentList = document.querySelector('.hover-me[data-linklist="'+link_id+'"]')
              parentList.classList.remove('active-hover');
            }
          });

      },
      LoadHover() {
        let am = this
        UTILS.ConvertStringToJS(am.$el.querySelector('[data-mega-json-'+handle+']').innerHTML)
        am.link = link
      }
    }))  

  })
})();
(() => {
  document.addEventListener('alpine:init', () => {
    // Linked Products variant switching
    Alpine.data('LinkedProducts', (linkingOptionName) => ({
      linkingOptionName: '',
      $section: null,
      $products: [],
      products: [],
      
      init() {
        let am = this;
        am.linkingOptionName = linkingOptionName;

        document.addEventListener('init-LinkedProducts', (e) => {
          if (am.$section) return;

          am.$section = e.target;
          am.$products = [...am.$section.querySelectorAll('[data-linked-product]')];

          // init products on page load
          (async () => {
            let px_products = am.$products.map(($item) => {
              let handle = $item.dataset.linkedProduct;
              return fetch(`/products/${handle}.js`).then(res => res.json());
            });

            am.products = await Promise.all(px_products);
            am.UpdateLinkedProductUrls();
          })();
        });

        // Listen for variant changes on the current product
        subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
          am.UpdateLinkedProductUrls(e.data.variant.options);
        });
      },

      UpdateLinkedProductUrls(current_values) {
        let am = this;

        if (!am.products.length) return;

        am.$products.forEach(($product) => {
          let handle = $product.dataset.linkedProduct;
          let product = am.products.find(p => p.handle == handle);

          if (!product) return;

          // Get current values from data attribute if not passed in
          if (!current_values) {
            current_values = JSON.parse($product.dataset.current_values);
          }

          // Find which option indices to match (exclude the linking option by name)
          let optionIdsToMatch = [];
          let valuesToMatch = [];
          
          product.options.forEach((optionName, index) => {
            if (optionName !== am.linkingOptionName) {
              const optionIndex = index + 1; // Shopify uses 1-based indexing
              optionIdsToMatch.push(optionIndex);
              
              // Get the corresponding value from current product
              // This assumes options are in the same order across products
              if (current_values[index]) {
                valuesToMatch.push(current_values[index]);
              }
            }
          });

          // Find matching variant in linked product
          let matching_variant = product.variants.find((v) => {
            // Build a string of the variant's option values for comparison
            let v_options = optionIdsToMatch.map((id) => v[`option${id}`]).join('/');
            return v_options == valuesToMatch.join('/');
          });

          // Fallback to first available variant if no match
          if (!matching_variant) {
            matching_variant = product.variants.find(v => v.available);
          }
          
          // Final fallback: use first variant
          if (!matching_variant && product.variants.length > 0) {
            matching_variant = product.variants[0];
          }

          if (!matching_variant) return;

          // Update the link with the variant ID
          $product.setAttribute('href', `/products/${handle}?variant=${matching_variant.id}`);

          // Apply disabled class if not available
          const label = $product.querySelector('label');
          if (label) {
            label.classList.toggle('disabled', !(matching_variant && matching_variant.available));
          }
        });
      }
    }));
  });
})();